var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deliv_photo)?_c('v-img',{attrs:{"src":_vm.deliv_photo,"contain":""},on:{"click":_vm.show}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }